import { useContext, useState } from 'react'
import { AppContext } from '../../../contextApi/ContextApi';
import { DashboardContext } from '../../../contextApi/DashboardContext';
import FormInput from './FormInput';
import FormTextarea from './FormTextarea';
import FormDropdown from './FormDropdown';
import FormAddImage from './FormAddImage';
import FormButton from './FormButton';
import { media } from '../../../dataSets/media';

export default function ProductPageSection({ _id, _label, _element, _parameter , _content, _inputType=null, _dropDownOptions=null }) {
    const {currentWebsite, setToastMessage, messagesOptions } = useContext(AppContext);
    const { handleUpdateProduct, currentProduct } = useContext(DashboardContext);
    const [editFlag, setEditFlag] = useState(false);
    const [content, setContent] = useState(_content);

    // update the product section data
    const update = async()=>{
        if(editFlag){
            handleUpdateProduct(currentWebsite, currentProduct._id, currentProduct.categoryID, _parameter, _inputType==="number" ? parseInt(content) : content, setToastMessage, messagesOptions)
        }
        setEditFlag(!editFlag);
    }

    const getElement =()=>{
        switch(_element){
            // ====================
            // Get an input element
            // ====================
            case "input" : return <FormInput id={_id} type={_inputType}
                placeholder={
                    // prevent the NaN displayd on the placeholder when erase value on change
                    _inputType==="number"&&content===null ? 0 : content
                }
                _value={
                    // On a number input, if needs percentage then make sure to set boundaries
                    // If 0 percent then give a message to user
                    // If more then hundred percent => adjust it to be 100 exact
                    // On price make sure if price set to be 0 then call it as free
                    // Otherwise set the value as the content state
                    // If fail displays a relevant message

                    _inputType==="number"&&content===0&&_label==="אחוז המבצע:" ? "אין מבצע - מחיר רגיל" :
                    _inputType==="number"&&content===0&&_label==="מחיר המוצר:" ? "Free" :
                    _inputType==="number"&&content>=100&&_label==="אחוז המבצע:" ? 100 :
                    _inputType==="number"&&content<0 ? 0 :
                    content
                }
                onChangeAction={(e)=>{
                    // Parse content to be an int if user typed some other value at a number input
                    // Prevent NaN if the input is an empty string
                    // Adjust the precentage to be 3 numbers max
                    // Else if not number just return the original value
                    setContent(
                        _inputType==="number"&&e.target.value.length===0 ? 0 :
                        _inputType==="number"&&_label==="מחיר המוצר:"&&e.target.value.length>0 ? parseInt(e.target.value) :
                        _inputType==="number"&&_label==="אחוז המבצע:"&&e.target.value.length>0 ? parseInt(e.target.value.slice(0,3)) :
                        e.target.value
                    )
                }} hasLabel={true} label={_label} hasButton={true} buttonText={editFlag ? "שמור" : "עדכן"} buttonAction={()=>{update()}} editFlag={editFlag} required={true}/>
            
            // ======================
            // Get a textarea element
            // ======================
            case "textarea" : return <FormTextarea id={_id} placeholder={content} onChangeAction={(e)=>{setContent(e.target.value)}} hasButton={true} buttonText={editFlag ? "שמור" : "עדכן"} buttonAction={()=>{update()}} editFlag={editFlag} label={_label} _value={content} required={null}/>
            
            // ====================
            // Get a select element
            // ====================
            case "select" : return <FormDropdown editFlag={editFlag} _value={content===true ? _dropDownOptions[0] : content===false ? _dropDownOptions[1] : content} hasButton={true} buttonText={editFlag ? "שמור" : "עדכן"} buttonAction={()=>{update()}} hasLabel={true} label={_label} id={_id} list={_dropDownOptions} onChangeAction={(e)=>{setContent(()=>{
                const val = e.target.value;
                return val==="כן" || val==="מלאי" ? true : val==="לא"||val==="יחיד" ? false : val;
            })}}/>
            
            // ====================
            // Get an image element
            // ====================
            case "image" : return (<div className='dashboardForm_section_imageChanger'>
                    <h3>{_label}</h3>
                    <img src={_content || media.webingoLogo} alt="productImage"/>
                    {editFlag ? <FormAddImage website={currentWebsite} uniqueAction={{update:handleUpdateProduct, setFlag:setEditFlag}} uniqueData={{a:currentWebsite, b:currentProduct._id, c:currentProduct.categoryID, d:_parameter, e:content, f:setToastMessage, g:messagesOptions}} toUpdateDoc={false} arrayIndex={null} directory={"products"} dynamicPath={"settings.categories"} isArray={true} label={"החלף תמונה"} text={"שמור"} type={"button"} _required={true} _id={"product_image_uploader"}/> : <FormButton disabled={false} type={"button"} text={"עדכן"} action={()=>{setEditFlag(!editFlag)}}/>}
                </div>)
        }
    }
    return (
        <div className="dashboard_productPage_section">
            {/* displays the relevant element on each render of that component according to data given from parent */}
            {getElement()}
        </div>
    )
}
